import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { RotateCcw } from "lucide-react";
import { api, money } from "../../lib/api";
import { OrderStatusTimeline } from "../../components/OrderCard";

export default function WholesaleOrders() {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/wholesale/orders").then(({ data }) => setOrders(data)).catch(() => {});
  }, []);

  const reorder = (item) => {
    const quantities = {};
    item.sizes.forEach((s) => { quantities[s.size] = s.qty; });
    navigate(`/gym/order/${item.product_id}`, {
      state: { prefill: { quantities, color: item.color } },
    });
  };

  return (
    <div className="px-5 lg:px-8 py-8">
      <p className="font-mono text-emerald-400 uppercase tracking-widest text-xs">Wholesale</p>
      <h1 className="font-heading font-black uppercase text-4xl text-white mt-1">Orders & Reorder</h1>

      {orders.length === 0 ? (
        <div className="text-zinc-500 font-mono py-16 text-center bg-[#121216] border border-white/10 rounded-lg mt-8">
          No wholesale orders yet. <Link to="/gym/catalog" className="text-emerald-400">Start an order →</Link>
        </div>
      ) : (
        <div className="space-y-4 mt-8">
          {orders.map((o) => (
            <div key={o.id} data-testid={`wholesale-order-${o.order_number}`} className="bg-[#121216] border border-white/10 rounded-lg p-6">
              <div className="flex flex-wrap justify-between gap-4 border-b border-white/10 pb-4 mb-4">
                <div>
                  <p className="font-mono font-bold text-emerald-400 text-lg">{o.order_number}</p>
                  <p className="text-xs text-zinc-500">{o.academy_name} · {(o.created_at || "").slice(0, 10)} · {o.units} units</p>
                </div>
                <div className="text-right">
                  <span className="font-mono text-xs uppercase bg-white/5 border border-white/10 px-2 py-1 rounded text-yellow-400">{o.status}</span>
                  <p className="font-mono font-bold text-white mt-2">{money(o.total)}</p>
                  {o.card_fee > 0 && <p data-testid={`order-card-fee-${o.order_number}`} className="text-[10px] font-mono text-zinc-500">incl. {money(o.card_fee)} card fee ({o.card_fee_pct}%)</p>}
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-3">
                  {o.items.map((it, i) => (
                    <div key={i} className="flex items-start justify-between gap-3">
                      <div>
                        <p className="text-white text-sm font-semibold">{it.product_name} {it.color ? `· ${it.color}` : ""}</p>
                        <p className="font-mono text-xs text-zinc-500">{it.sizes.map((s) => `${s.size}×${s.qty}`).join("  ")}</p>
                      </div>
                      <button data-testid={`reorder-${o.order_number}-${i}`} onClick={() => reorder(it)} className="btn-outline inline-flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-[11px] shrink-0">
                        <RotateCcw className="h-3 w-3" /> Reorder
                      </button>
                    </div>
                  ))}
                </div>
                <OrderStatusTimeline status={o.status} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
